// Import the echarts core module, which provides the necessary interfaces for using echarts.
import * as echarts from 'echarts/core';

// Import bar charts, all suffixed with Chart
import { BarChart } from 'echarts/charts';

// Import the tooltip, title, rectangular coordinate system, dataset and transform components
import { TitleComponent, TooltipComponent, GridComponent, DatasetComponent, TransformComponent } from 'echarts/components';

// Features like Universal Transition and Label Layout
import { LabelLayout, UniversalTransition } from 'echarts/features';

// Import the Canvas renderer
// Note that including the CanvasRenderer or SVGRenderer is a required step
import { CanvasRenderer } from 'echarts/renderers';

// echarts 6 redesigned its default and dark themes. These are snapshots of the echarts 5 look (Apache ECharts,
// Apache-2.0): v5.json is echarts' own theme/v5.js; v5-dark.json is that theme with echarts 5's dark theme on top.
import v5Theme from './themes/v5.json';
import v5DarkTheme from './themes/v5-dark.json';

/** Theme names to pass to `init()`, matching the app's light and dark mode */
export const CHART_THEME = { light: 'posito-v5-light', dark: 'posito-v5-dark' } as const;

// echarts 6 shrinks the plot area so axis labels never overflow ('auto'); echarts 5 didn't
const v5Layout = { grid: { outerBoundsMode: 'none' } };

function initEcharts() {
  // Register the required components
  echarts.use([
    BarChart,
    TitleComponent,
    TooltipComponent,
    GridComponent,
    DatasetComponent,
    TransformComponent,
    LabelLayout,
    UniversalTransition,
    CanvasRenderer,
  ]);

  echarts.registerTheme(CHART_THEME.light, echarts.util.merge(echarts.util.clone(v5Theme), v5Layout, true));
  echarts.registerTheme(CHART_THEME.dark, echarts.util.merge(echarts.util.clone(v5DarkTheme), v5Layout, true));
}

export { echarts, initEcharts };
